import React from "react";

import { Row, Col, FormControl, Checkbox } from "react-bootstrap";

import Form from "./Form";
import Table from "./Table";
import Actions from "./Actions";

import EditCoachPoolContext from "../../../../contexts/EditCoachPoolContext";

export default function Index({ coachPool, coachSelected }) {
  return (
    <EditCoachPoolContext coachPool={coachPool} coachSelected={coachSelected}>
      <div className="wrapper_assestment invite_wrapper">
        <Form />

        <div className="mt20">
          <Table />
        </div>
        <Actions />
      </div>
    </EditCoachPoolContext>
  );
}
